const initialState = {
    caseManagerOrParoleAgent: {
        id: '',
        value: '',
    },            
    roleType: {
        id: '',
        value: '',
    },
    recordEpdCntID: '',
    startDate: '',
    endDate: '',
    newAorcm: false,
}

export default initialState;